import React, { useContext } from 'react';
import { ChangeDetailData } from '../../services/model';
import { ChangeDetail } from './ChangeDetail';
import { Store } from '../Store';

type ChangeDetailListProps = { changeScope: string; changeDetails: ChangeDetailData[] };

export const ChangeDetailList: React.FC<ChangeDetailListProps> = ({ changeScope, changeDetails }) => {
    const { filter } = useContext(Store);

    return (
        <table className="table col-12">
            <thead>
                <tr>
                    <th scope="col" className="cursor-pointer col-3">
                        {changeScope}
                    </th>
                    <th scope="col" className="col-3">
                        State
                    </th>
                    <th scope="col" className="col-5">
                        Comment
                    </th>
                </tr>
            </thead>
            <tbody>
                {changeDetails
                    .filter(
                        (changeDetail) =>
                            !filter ||
                            filter
                                .toLowerCase()
                                .split(/\s+/)
                                .every((word) => changeDetail.subject.includes(word))
                    )
                    .map((data, index) => (
                        <ChangeDetail
                            subject={data.subject}
                            isCompliant={data.isCompliant}
                            compliantSince={data.compliantSince}
                            key={index}
                        />
                    ))}
            </tbody>
        </table>
    );
};
